/**
 * Production-safe logger. Only outputs in development.
 * Import and use instead of console.log/debug/warn.
 */
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
